

<script lang="ts">
  import type { OrganizationUser } from "@kontextwerk/control-web-client"
  import type { UserViewFrameContext } from "../../_shared/_logic/user-types"
  import type { PageTabWithId } from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
  import type { PageContext } from "./navigation"
  import UserWorkingHoursTab from "../WorkingHoursPage/tabs/WorkingHoursTab"

  const { viewFrameContext, activeTab } = $props<{
    viewFrameContext: UserViewFrameContext
    activeTab: string
  }>()

  const pageContext = $derived.by<PageContext>(() => ({
    user: viewFrameContext.user,
    organizationId: viewFrameContext.organizationId,
    loading: viewFrameContext.loading,
    error: viewFrameContext.error,
    onRetry: viewFrameContext.onRetry ?? null,
    onUpdated: viewFrameContext.onUpdated,
  }))
</script>

{#if activeTab === "working-hours"}
  <UserWorkingHoursTab {viewFrameContext} {pageContext} />
{/if}
